import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection, toggleUploadModal } from "../../../actions";
import Intro from "./Intro";
import Dialog from "../../Dialog";
import UserArt from "../../UserArt";
import UploadButton from "./UploadButton";
// import EditButtons from './EditButtons'
// import CropButtons from './CropButtons'
import localStorageWrapper from "../../../services/localStorageWrapper";

class PhotosTools extends React.Component {
  state = {
    showDialog: false,
    customPhotoCupDialog: false,
  };

  componentDidMount() {
    // Set 'Photos' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Photos" });

    this.dialog = {
      title: "Designer's Tip",
      message:
        "Any white in art will not be printed and will be left the color of the product.",
      topPosition: 260,
      leftPosition: 50,
      origin: "topleft",
    };

    this.customPhotoCupDialog = {
      title: "WARNING!",
      message:
        "Any white in your artwork, including backgrounds, will be printed on the cup.",
      topPosition: 260,
      leftPosition: 50,
      origin: "topleft",
      // This prop (type) is optional, if not provided it will default to the green colored dialogs used across the board.
      // 'warning' is the only currently supported prop type.
      type: "warning",
    };

    // Expiration for local storage
    const now = Date.now(),
      expires = 60 * 60 * 1000 * 24;

    if (
      !this.state.showDialog &&
      !localStorageWrapper.getItem("fypUploadDisclaimerShown")
    ) {
      // Set local storage for 24 hours to remember that the tips have been shown
      localStorageWrapper.setItem("fypUploadDisclaimerShown", true);
      localStorageWrapper.setItem("fypUploadDisclaimerShownTimestamp", now);

      this.setState({
        customPhotoCupDialog: true,
        showDialog: true,
      });
    }

    // Delete local storage after 24 hours
    if (
      now - localStorageWrapper.getItem("fypUploadDisclaimerShownTimestamp") >
      expires
    ) {
      localStorageWrapper.removeItem("fypUploadDisclaimerShown");
      localStorageWrapper.removeItem("fypUploadDisclaimerTimestamp");
    }
  }

  handleHideCupDialog = () => {
    this.setState({
      customPhotoCupDialog: false,
    });
  };

  handleHideWhiteDialog = () => {
    this.setState({
      showDialog: false,
    });
  };

  onShowUploadModal = () => {
    this.props.toggleUploadModal({
      isVisible: true,
      type: "photo",
    });
  };

  render() {
    const userArtArray = this.props.upload.user_art.entities;
    const countPhotos = userArtArray.filter((obj) => {
      return obj.field_type === "photo";
    }).length;

    //Variable prep ahead of redux store checks
    const productInfo = this.props.productOption.entity;
    const dataTarget = "product_variant_id";
    const custom_photo_cup_var_id = 908;
    let isCustomPhotoCup = false;

    //Check to see if entity data has been populated before scanning the keys for aforementioned product variant IDs
    if (productInfo) {
      // Map the Redux Store entity object that contains product data, and searches for product variant IDs we need
      Object.keys(productInfo).map((key) => {
        if (productInfo[dataTarget] == custom_photo_cup_var_id) {
          isCustomPhotoCup = true;
        }
      });
    }

    return (
      <div className="tools-container tools-container--photos">
        {this.state.customPhotoCupDialog &&
          this.customPhotoCupDialog &&
          isCustomPhotoCup == true && (
            <Dialog
              dialog={this.customPhotoCupDialog}
              onHideDialog={this.handleHideCupDialog}
            />
          )}

        {this.state.showDialog && this.dialog && isCustomPhotoCup == false && (
          <Dialog
            dialog={this.dialog}
            onHideDialog={this.handleHideWhiteDialog}
          />
        )}
        <Intro />

        <UploadButton onShowUploadModal={this.onShowUploadModal} />

        {countPhotos > 0 && (
          <div>
            <h4 className="tool__header">Your Photos</h4>
            <UserArt imageType="photo" />
          </div>
        )}

        {/*<EditButtons/>*/}
        {/*<CropButtons/>*/}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    upload: state.upload,
    uploadModal: state.upload.isVisible,
    productOption: state.productOption,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection,
      toggleUploadModal,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotosTools);
